"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schedule_email_modal_html_1 = __importDefault(require("./schedule-email-modal.html"));
require("./schedule-email-modal.less");
(function (module) {
    'use strict';
    module.factory('prScheduleEmailModal', [
        'qstrap.modal',
        function (modal) {
            function show() {
                return modal({
                    show: true,
                    templateUrl: schedule_email_modal_html_1.default
                });
            }
            return {
                show: show
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
